export class ReviewInteractions {
  /**
   * Integer number of upvotes/likes
   */
  upVotes: number;

  /**
   * Integer number of downvotes/dislikes
   */
  downVotes: number;

  /**
   * If this review has been reported offensive
   */
  reportedOffensive: boolean;

  /**
   * If this user has upvoted/liked this review
   */
  myUpVote: boolean;

  /**
   * If this user has downvotes/disliked this review
   */
  myDownVote: boolean;

  /**
   * If this user has reported this review offensive
   */
  myReportedOffensive: boolean;

  /**
   * Parses reviewSubrating
   * @param data {any} ReviewSubrating data as returned by API
   * @return {ReviewSubrating} Parsed ReviewSubrating
   */
  static parse(data: any): ReviewInteractions {
    return {
      upVotes: data.upVotes,
      downVotes: data.downVotes,
      reportedOffensive: data.reportedOffensive,
      myUpVote: data.myUpVote,
      myDownVote: data.myDownVote,
      myReportedOffensive: data.myReportedOffensive
    };
  }
}
